<template>
  <page-frame>
    <component @initialize="redirect" @ReloadImage="ReloadImage" @login="login" :is="LoginType" :textCode="textCode" :checkImageUrl="checkImageUrl" v-model="model"></component>
  </page-frame>
</template>
<script>
  import authorizat from "./modules/authorizat.vue";
  export default {
    data() {
      return {
        LoginType: "authorizat",
        judgeCode: true,
        textCode: "system.TestGetCode",
        model: {
          UserAct: "",
          UserPwd: "",
          UserCode: "",
          IsRemember: true,
          DeviceInfo: "App",
          ValidCode: "",
          LoginMode: "",
          isLogin: true,
        },
        checkImageUrl: "",
      };
    },
    created() {
      let __self = this;
      __self.ReloadImage();
    },
    methods: {
      ReloadImage() {
        var __self = this;
        __self.checkImageUrl = `/api/side/common/ValidCode?${Math.random()}`;
      },
      login(data) {
        let __self = this;
        __self.$store.dispatch("signIn", data).then(response => {
          if (!response.isSucc) {
            this.$root.$toast.fail(response.message);
            return response;
          }
          // if (response.data.result && response.data.result.FeatureCodes && response.data.result.FeatureCodes.indexOf("initialize.password") >= 0) {
          //   __self.model.isLogin = false;
          //   return;
          // }
          this.$root.$toast.success(__self.$t("share.succ.LoginSucc"));
          __self.redirect();
        });
      },
      redirect() {
        let __self = this;
        let redirect = __self.$route.query.redirect;
        // redirect = redirect && redirect.indexOf("redirect") == -1 ? redirect : "/";
        location.href = redirect;
      },
    },
    components: {
      authorizat,
    },
  };
</script>
